import React from 'react';
import { faUserPlus } from '@fortawesome/free-solid-svg-icons';

import Icon from './Icon';

const UserPlusIcon = ({ toolTipText = 'Add Family Member' }) => (
  <Icon tooltip={ toolTipText } iconObj={faUserPlus} />
);

export default UserPlusIcon;